import type { Components, Theme } from "@mui/material";

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        display: "flex",
        flexDirection: "row",
        gap: ".25rem",
        borderRadius: ".5rem",
        paddingLeft: 0,
        paddingRight: 0,
        height: "1.5rem",
        ...theme.typography.pill,
      };
    },
  },
  variants: [
    {
      props: {
        variant: "error",
      },
      style: ({ theme }) => {
        return {
          ...theme.typography.pill,
          padding: ".5rem .5rem .5rem .5rem",
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
        };
      },
    },
    {
      props: {
        variant: "info",
      },
      style: ({ theme }) => {
        return {
          ...theme.typography.pill,
          backgroundColor: theme.palette.info.light,
          color: "#214294",
        };
      },
    },
    {
      props: {
        variant: "success",
      },
      style: ({ theme }) => {
        return {
          ...theme.typography.pill,
          backgroundColor: theme.palette.success.light,
          color: "#009F3F",
        };
      },
    },
    {
      props: {
        variant: "warning",
      },
      style: ({ theme }) => {
        return {
          ...theme.typography.pill,
          backgroundColor: theme.palette.warning.light,
          color: "#E67800",
        };
      },
    },
    {
      props: {
        variant: "onTrack",
      },
      style: ({ theme }) => {
        return {
          // ...theme.typography.subtitle1,
          backgroundColor: theme.palette.warning.light,
          color: "#E67800",
        };
      },
    },
    {
      props: {
        variant: "inProgress",
      },
      style: ({ theme }) => {
        return {
          backgroundColor: theme.palette.warning.light,
          color: "#E67800",
        };
      },
    },
    {
      props: {
        variant: "reportCount",
      },
      style: ({ theme }) => {
        return {
          fontSize: ".625rem",
          fontWeight: 500,
          lineHeight: "1rem",
          letterSpacing: "-.025rem",
          padding: ".125rem .25rem",
          textTransform: "uppercase",
          borderRadius: ".25rem",
          minWidth: ".875rem",
          height: "1.125rem",
          background: "#436EDA",
          color: theme.palette.purple.contrastText,
        };
      },
    },
    {
      props: {
        variant: "due",
      },
      style: ({ theme }) => {
        return {
          fontSize: ".6875rem",
          fontWeight: 800,
          lineHeight: "1rem",
          padding: ".125rem .25rem",
          letterSpacing: "-.0275rem",
          textTransform: "uppercase",
          borderRadius: ".25rem",
          minWidth: ".875rem",
          backgroundColor: theme.palette.purple.main,
          color: theme.palette.purple.contrastText,
        };
      },
    },
  ],
};
